// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1JYAZ","inner":"styles_inner__1nvaY","wrap":"styles_wrap__3eP9U","forgot":"styles_forgot__20dIo","verfiy_input_row":"styles_verfiy_input_row__1j2qI"};